<template>
  <div class="chat-app__wrapper" ref="chatWrapper">
    <div class="chat-app__scrollbar-wrapper">
      <div v-if="attention" @click="scrollToAttention(attention)">
        <div class="chat-attention">
          <div class="chat-attention__wrapper">
            <div class="chat-attention__body">
              <img v-if="replaceSticker(attention.msg)" :src="replaceSticker(attention.msg)"/>
              <nl2br v-else tag="span" :text="truncateMessage(attention.msg)"/>
            </div>
          </div>
        </div>
      </div>
      <perfect-scrollbar
          id="container"
          class="chat-app__scrollbar"
          @ps-scroll-y="handleScroll"
          @ps-y-reach-end="reachEnd"
          ref="perfectscrollbar"
      >
        <message
            v-for="(message, index) in messages"
            v-bind:message="message"
            v-bind:index="index"
            v-bind:key="message.id"
            :on-answer="onAnswer"
            :on-delete="onDelete"
            :on-mark-attention="onMarkAttention"
            :on-unmark-attention="onUnmarkAttention"
            :on-mark-question="onMarkQuestion"
            :on-unmark-question="onUnmarkQuestion"
            :on-ban="onBan"
            :on-like="onLike"
            :on-dislike="onDislike"
        ></message>
      </perfect-scrollbar>
    </div>

    <div v-if="newMsgReceived && isScrolling" class="chat-new-messages">
      <div class="chat-new-messages__wrapper">
        <div class="chat-new-messages__body" @click="scrollToBottom">
          {{ getNewMessageButtonLabel() }}
          <v-icon color="white" size="32px">mdi-chevron-down</v-icon>
        </div>
      </div>
    </div>
    <quote v-if="quote" :message="quote" @update-quote="clearQuote"/>
    <div class="chat-app__message-form">
      <v-menu
          v-if="site === 'urotv'"
          v-model="menu"
          :close-on-content-click="true"
          :nudge-width="200"
          transition="slide-y-transition"
          top
          left
          offset-x
          offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              icon
              class="chat-app__sticker-button"
              absolute="absolute"
              v-bind="attrs"
              v-on="on"
          >
            <v-icon size="28px">mdi-sticker-circle-outline</v-icon>
          </v-btn>
        </template>

        <v-card>
          <perfect-scrollbar
              class="chat-app__sticker-collection"
              ref="perfectscrollbar"
          >
            <div v-for="(n) in 12" :key="n" class="chat-app__sticker-item">
              <img
                  v-bind:alt="n"
                  v-bind:src="'https://chat.uro.tv/static/stickers/shark/sticker-' + n + '.svg'"
                  v-on:click="sendSticker(n)"
              />
            </div>
          </perfect-scrollbar>
        </v-card>
      </v-menu>


      <v-btn
          dark
          icon
          absolute="absolute"
          class="chat-app__send-button"
          @click="sendMessage"
      >
        <v-icon
            size="32px"
        >
          mdi-send
        </v-icon>
      </v-btn>

      <v-textarea
          v-on:keyup.enter="sendMessage"
          id="textareaDonor"
          :label="label"
          :value="message"
          v-model="message"
          class="chat-app__message-input"
          outlined
          background-color="#f7f7f7"
          :rows="rowsCount"
          :auto-grow="autoGrow"
          height="auto"
          @input="countLabel"
          maxlength="1000"
          @focusin="onFocusInEvent"
          @focusout="onFocusOutEvent"
          :disabled="isDisabled"
          :placeholder="getPlaceHolder"
      />
    </div>
    <div id="hidden-text" style="position: absolute; visibility: hidden;
        width: auto; height: auto; white-space: nowrap">{{ this.message }}
    </div>
  </div>
</template>

<script>

import Message from "./Message";
import Quote from "./Quote";
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import {localize} from "@/store/modules/localization"
import {cleanMessage, replaceSticker} from "@/helpers";
import config from "@/config";

// const defaultLabel = localize('Write a message', 'ru')

export default {
  components: {Message, Quote, PerfectScrollbar},
  name: "ChatMessages",
  computed: {
    messages() {
      return this.$store.getters.getMessages
    },
    attention() {
      const att = this.$store.getters.getAttentions
      if (att.length) return att[att.length - 1]
      return false
    },
    isScrolling() {
      return this.$store.getters.getIsScrolling
    },
    newMsgReceived() {
      return this.$store.getters.getNewMessageReceived
    },
    isDisabled() {
      return this.$store.getters.amIGuest && !this.$settings.guestcanwrite
    },
    getPlaceHolder() {
      return this.isDisabled ? localize('Registration required', this.$settings.lang) : null
    }
  },
  data() {
    return {
      message: "",
      roomId: 0,
      quote: null,
      rowsCount: 2,
      autoGrow: true,
      label: localize('Write a message', this.$settings.lang),
      site: this.$settings.site || config.SITE,
    }
  },
  props: ['onDelete', 'onMarkAttention', 'onUnmarkAttention', 'onMarkQuestion', 'onUnmarkQuestion', 'onBan', 'onLike', 'onDislike'],
  methods: {
    sendMessage() {
      var msg = this.message.trim()
      const params = {cmd: 'msg', body: msg}
      if (this.quote !== null) {
        params['quote'] = this.quote.id
      }
      this.$store.dispatch('sendWsMsg', params)
      this.message = ""
      this.quote = null
      this.countLabel()
    },
    sendSticker(n) {
      var msg = ":shark-"+n+":"
      const params = {cmd: 'msg', body: msg}
      if (this.quote !== null) {
        params['quote'] = this.quote.id
      }
      this.$store.dispatch('sendWsMsg', params)
      this.message = ""
      this.quote = null
      this.countLabel()
    },
    onAnswer(msg) {
      this.quote = msg
    },
    joinRoom() {
      this.$store.dispatch('truncateQuoteList')
      this.$store.dispatch('truncateMessageList')
      this.$store.dispatch('truncateQuestionsList')
      this.$store.dispatch('truncateAttentionsList')
    },
    clearQuote(val) {
      this.quote = val
    },
    countLabel() {
      this.label = `${localize('Write a message', this.$settings.lang)} (${1000 - this.message.length}/1000)`
    },
    onFocusInEvent() {
      this.countLabel()
    },
    onFocusOutEvent() {
      if (!this.message) this.label = localize('Write a message', this.$settings.lang)
    },
    scrollToBottom() {
      var container = this.$el.querySelector("#container");
      container.scrollTop = container.scrollHeight;
    },
    handleScroll() {
      this.$store.dispatch('setScrolling', true)
      const contentHeight = this.$refs.perfectscrollbar.ps.contentHeight
      const elScrtollTop = this.$refs.perfectscrollbar.ps.element.scrollTop
      if (elScrtollTop < 150 && contentHeight > 300)
        this.loadHistory(contentHeight, elScrtollTop)
    },
    loadHistory(oldHeight, oldScrollTopPos) {
      const vm = this

      if (!this.$store.getters.getHistoryIsFullLoaded && this.messages.length && !this.$store.getters.getGettingOldMsgs) {
        const callback = () => {
          const container = vm.$el.querySelector("#container");
          container.scrollTop = container.scrollHeight + oldScrollTopPos - oldHeight
        }
        this.$store.dispatch('setHistoryCallback', callback).then(
            this.$store.dispatch('setGettingOldMsgs', true).then(
                this.$store.dispatch('sendWsMsg',
                    // FIXME: тут баг, если последние 10 сообщений будут помечены как вопросы
                    //  - то история не будет прогружатся
                    {cmd: 'get_msgs_before', body: `${this.messages.filter(m => !m.isQuestion)[0].id}`})))
      }
    },
    reachEnd() {
      this.$store.dispatch('setScrolling', false)
      this.$store.dispatch('setNewMessageReceived', false)
    },
    getNewMessageButtonLabel() {
      return localize('New messages', this.$settings.lang)
    },
    scrollToAttention(msg) {
      const el = document.querySelector(`#chat-message-${msg.id}`);
      el.scrollIntoView({behavior: 'auto', block: 'nearest', inline: 'end'})
    },
    truncateMessage(msg) {
      msg = cleanMessage(msg);

      return msg > 75 ? msg.substring(0, 75) + '..' : msg
    },
    replaceSticker(msg) {
      const wsUrl = this.$settings.websocket || this.$store.getters.getServer
      const host = wsUrl.replace('ws://', 'http://').replace('wss://', 'https://')
      const src = new URL('/static/stickers/shark/', host).href

      return replaceSticker(msg, src);
    }
  },
  updated() {
    const isMenuOpened = this.$store.getters.getMenuOpened
    const isScrolling = this.$store.getters.getIsScrolling
    if (!isMenuOpened && !isScrolling) this.scrollToBottom();
  },
}
</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>
